// frontend/src/api/reviews.js
import { apiClient } from './index';

const reviewsApi = {
  getPartReviews: async (partId) => {
    return await apiClient.get(`/reviews/${partId}`);
  },

  submitReview: async (data) => {
    // data: { part_id, rating, comment }
    return await apiClient.post('/reviews/', data);
  },

  // Admin
  getAllReviewsAdmin: async (status = null) => {
    const url = status ? `/reviews/admin/all?status=${status}` : '/reviews/admin/all';
    return await apiClient.get(url);
  },

  moderateReview: async (reviewId, status, reason = null) => {
    return await apiClient.put(`/reviews/admin/${reviewId}/moderate`, { status, rejection_reason: reason });
  }
};

export { reviewsApi };